type GetPageNumbersProps = {
    current: number;
    max: number;
    min: number;
    padding: number;
};

type PageProps =
    | {
          isFirst?: boolean;
          isLast?: boolean;
          key: string;
          kind: 'button';
          label: string;
          value: number;
      }
    | {
          key: string;
          kind: 'ellipsis';
      };

const paginationButtonProps = ({
    current,
    max,
    min,
    padding,
}: GetPageNumbersProps) => {
    let startPage;
    let endPage;

    if (max <= padding) {
        // If total pages is less than max pages to show, show all pages
        startPage = min;
        endPage = max;
    } else {
        // Calculate start and end pages
        const pagesBeforeCurrentPage = Math.floor(padding / 2);
        const pagesAfterCurrentPage = Math.ceil(padding / 2) - 1;

        if (current <= pagesBeforeCurrentPage) {
            // If current page is near the start, show the first pages
            startPage = min;
            endPage = padding;
        } else if (current + pagesAfterCurrentPage >= max) {
            // If current page is near the end, show the last pages
            startPage = max - padding + 1;
            endPage = max;
        } else {
            // Show pages around the current page
            startPage = current - pagesBeforeCurrentPage;
            endPage = current + pagesAfterCurrentPage;
        }
    }

    // Generate the array of page numbers
    const pageNumbers: PageProps[] = [];

    for (let index = startPage; index <= endPage; index += 1) {
        pageNumbers.push({
            key: `page ${index}`,
            kind: 'button',
            label: String(index),
            value: index,
        });
    }

    if (pageNumbers[0].kind === 'button' && pageNumbers[0].value !== min) {
        pageNumbers[0] = {
            isFirst: true,
            isLast: false,
            key: `page ${min}`,
            kind: 'button',
            label: '1',
            value: min,
        };

        pageNumbers[1] = {
            key: 'ellipse 1',
            kind: 'ellipsis',
        };
    }

    const lastPage = pageNumbers.at(-1);

    if (lastPage && lastPage.kind === 'button' && lastPage.value !== max) {
        pageNumbers[pageNumbers.length - 1] = {
            isFirst: false,
            isLast: true,
            key: `page ${max}`,
            kind: 'button',
            label: String(max),
            value: max,
        };

        pageNumbers[pageNumbers.length - 2] = {
            key: 'ellipse 2',
            kind: 'ellipsis',
        };
    }

    return pageNumbers;
};

export default paginationButtonProps;
